export enum OpportunityCustomerTypes {
    ARCHITECTURAL_STUDIO = 'Architectural studio',
    GC_AWARDED = 'Gc awarded',
    GC_TENDER = 'Gc tender',
    PRIVATE = 'Private'
}
